const state = {
  acumulados: {},
  gerais: {},
  material: {},
  setedias: {}
}

const mutations = {
  fillDataAcumulados (state, res) {
    // state.acumulados = res.data.grafico sd2018
    state.acumulados = res.data
    console.log(res)
  },
  fillDataGerais (state, res) {
    // state.gerais = res.data.grafico sd20218
    state.gerais = res.data
  },
  fillDataMaterial (state, res) {
    // state.material = res.data.grafico sd20218
    state.material = res.data
  },
  fillDataSeteDias (state, res) {
    // state.material = res.data.grafico sd20218
    state.setedias = res.data
  }
}

const actions = {
  createGraficoGerais(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios', data).then((res) => {
      context.commit('fillDataGerais', res)
      return res
    })
  },
  createGraficoSeteDias(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios/setedias', data).then((res) => {
      context.commit('fillDataSeteDias', res)
      return res
    })
  },
  createGraficoMateriais(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios', data).then((res) => {
      context.commit('fillDataMaterial', res)
      return res
    })
  },
  createGraficoAcumulados(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/relatorios/dias', data).then((res) => {
      context.commit('fillDataAcumulados', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js